import { render, staticRenderFns } from "./EventDeadlineConfig.vue?vue&type=template&id=1595bf29"
import script from "./EventDeadlineConfig.vue?vue&type=script&lang=js"
export * from "./EventDeadlineConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports